<template>
  <div id="app">
    <!-- 这里是需要keepalive的 -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <!-- 这里不会被keepalive -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <div class="app-help-btn" @click="$store.state.guanjiaEWMShow = true">
    ?
    </div>
    <el-dialog
        title=""
        :visible.sync="$store.state.guanjiaEWMShow"
        width="440px"
        :before-close="closeFn"
        :close-on-click-modal = 'false'
        :close-on-press-escape = 'false'
        class="guanjiaDialog"
    >
        <div class="diaBody">
            <div class="kefuIcon">
              <span>专属客服</span>
              <b></b>
            </div>
            <div class="text1">
              添加猿派企业微信
            </div>
            <div class="text2">
              专业人工咨询通道
            </div>
            <div  class="text3">
              1对1快速帮你解决问题，及时满足你的用人匹配需求。
            </div>
            <div  class="imgBox">
              <img :src="$store.state.guanjia" alt="" class="rzLoading">
          
              <div class="rzDesc">
                1对1解答问题
              </div>
            </div>
          
            <div class="btnBox btnBoxRz">
                <a :href="$store.state.guanjia" download="猿派管家二维码.jpg" target="_blank">保存二维码</a>
                <!-- <el-button type="primary" style="width:100%" @click="saveImg">保存二维码</el-button> -->
            </div>
        </div>
        
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
export default {
    name: 'App',
    created(){
      
      this.getEWM()
    },
    methods:{
      getEWM(){
        window.fdGlobal.ajax({
            method: 'POST',
            url: window.fdConfig.url.common('guanjia'),
            // URL参数
            // 必须是一个纯对象或者 URL参数对象
            headers: { 'content-type': 'application/x-www-form-urlencoded'},
            data: qs.stringify({}),
            //data: qs.stringify({id: 637}),
            //params: '',
            // 默认值是json
            responseType: 'json'
        }).then((data) => {
            
            if (data.data.code == '1') {
                this.$store.state.guanjia = data.data.data.name
                this.$store.state.guanjiaName = data.data.data.name2
            }else if (data.data.code == '2') {
                this.$message.warning(data.data.message);
            }
        }, (data) => {
            
            this.$message.error(data.data.message);
        });
      },
      closeFn(done){
        this.$store.state.guanjiaEWMShow=false
        done()
      },
      saveImg(){

      }
    }
};
</script>

<style lang="less">
  @import "./css/index.less";
  .el-message{
    z-index: 99999999999 !important;
  }
  .icon-question-pop{
    max-width: 470px;
    box-shadow: 0px 0px 24px 0px rgba(153, 153, 153, 0.3);
    border-color: #fff !important;
    padding: 10px 20px;
    // left: 225px !important;
    // top: 165px !important;
    .popper__arrow{
      border-color:rgba(153, 153, 153, 0) !important;
      // left: -12px !important;
      // top: -12px !important;
      &::after{
        // border-width:10px
      }
    }
    .listItem{
      color: #333;
      font-size: 12px;
      display: flex;
      align-items: flex-start;
      line-height: 30px;

      span{
        color: #999;
        display: inline-block;
        width: 80px;
      }
      i{
        width: 3px;
        height: 3px;
        background: #999999;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
        margin-top: 14px;
      }
      p{
        flex: 1;
      }
    }
  }
  .icon-question-jspop{
    max-width: 550px;
    .listItem{
      span{
        color: #999;
        display: inline-block;
        width: 110px;
      }
    }
  }
  .form3Tool-pop{
    max-width: 600px;
  }
  .cui-ribbonTopBars{
    display: none !important;
  }
  .el-notification{
    cursor: pointer;
    .el-notification__content{
      p{
        color: #0061C8;
      }
    }
  }
  .submitDiaXY{
    .el-message-box__header{
      .el-message-box__headerbtn{
        display: none;
      }
      .el-message-box__title{
        padding-top: 20px;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 24px;
        color: #000000;
      }
    }
    .el-message-box__content{
      p{
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #8C8C8C;
      }
    }
    .el-message-box__btns{
      display: flex;
      justify-content: center;
      padding-bottom: 15px;
      button{
        width: 120px;
        height: 40px;
        &:nth-of-type(2){
          margin-left: 40px;
        }
      }
    }
  }
  .submitDiaXY2{
    width: 640px !important;
  }
  .weiqianyue2{
    
    .el-dialog{
      width: 652px;
      
    }
    .el-dialog__header{
      display: block !important;
    }
    .right{
      >div{
        &:nth-of-type(1){
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 24px !important;
          /* or 150% */

          display: flex;
          align-items: center;
          text-align: center;

          /* light/text/--el-text-color-primary */

          color: #303133 !important;
          opacity: 1 !important;
        }
        &:nth-of-type(2){
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 24px !important;
          /* or 150% */

          display: flex;
          align-items: center;
          text-align: center;

          /* light/text/--el-text-color-primary */

          color: #303133 !important;
          opacity: 1 !important;
          margin-top: 0px !important;
        }
        &:nth-of-type(3){
          font-weight: 400;
          font-size: 14px;
          line-height: 22px !important;
          /* identical to box height, or 157% */

          display: flex;
          align-items: center;
          text-align: center;

          /* light/text/--el-text-color-secondary */

          color: #909399;
          margin-top: 4px;
        }
      }
      .el-button{
        background: #1A5CF5;
        border-color: #1A5CF5;
      }
    }

  }
  
  .msgHeader{
    display: flex;
    align-items: center;
    justify-content: space-between;
    >div{
      &:nth-of-type(1){
        color: #242424;
      }
      &:nth-of-type(2){
        width: 210px;
      }
    }
  }
  .el-popover{
    .msgBox{
      .addBtn{
        width: 100%;
        height: 33px;
        border: 1px solid #C7C7C7;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        margin: 0 auto;
        margin-top: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span{
          font-size: 20px;
          color: #242424;
        }
      }
    }
    .noMsg{
      padding-top: 32px;
      padding-bottom: 20px;
      div{
        text-align: center;
        &:nth-of-type(1){
          color: #000;
          font-size: 14px;
        }
        &:nth-of-type(2){
          font-size: 12px;
          color: #919191;
          margin-top: 3px;
        }
        &:nth-of-type(3){
          margin-top: 24px;
          line-height: 32px;
          background: #409EFF;
          color: #fff;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
    .addMsgInfo{
      >div{
        margin-top: 10px;
        >div{
          &:nth-of-type(1){
            font-size: 12px;
            color: #616161;
            margin-bottom: 8px;
          }
        }
      }
      .sureAddMsg{
        text-align: center;
        cursor: pointer;
        background: #409EFF;
        color: #fff;
        line-height: 32px;
        border-radius: 4px;
        margin-top: 20px;
      }
      .cancelAddMsg{
        text-align: center;
        cursor: pointer;
        margin-top: 17px;
      }
      
    }
    .msgItem{
      
      position: relative;
      &:hover{
        background: #ecf5ff !important;
      }
      >div{
        
        &:nth-of-type(1){
          color: #424242;
          
          padding: 0 8px;
          padding-top: 8px;
          font-size: 12px;
          color: #424242;
          font-family: 'Source Han Sans CN';
          line-height: 20px;
        }
        &:nth-of-type(2){
          
          padding: 0 8px;
          font-size: 12px;
          color: #424242;
          font-family: 'Source Han Sans CN';
          line-height: 20px;
          color: #838383;;
        }
      }
      span{
        position: absolute;
        right: 20px;
        top: 20px;
       
      }
    }
    .msgWrap{
      max-height: 392px;
      overflow-y: auto;
      margin-top: 10px;
    }
    .mianshiWrap{
      background: #fff;
      >div{
        background: rgba(255, 0, 0, .04);   
        height: 47px;   
        color: #000;
        padding: 6px 8px;
        >div{
          width: 100%;
          display: flex;
          font-size: 12px;
          &:nth-of-type(1){
            justify-content: space-between;
          }
          &:nth-of-type(2){
            justify-content: flex-end;
          }
        }
      }
    }
    /* 设置滚动条的样式 */
      ::-webkit-scrollbar {
        width:10px;
      }
      /* 滚动槽 */
      ::-webkit-scrollbar-track {
      -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
      border-radius:10px;
      }
      /* 滚动条滑块 */
      ::-webkit-scrollbar-thumb {
      border-radius:10px;
      background:rgba(0,0,0,0.1);
      -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
      }
      ::-webkit-scrollbar-thumb:window-inactive {
      
      }
  }
  /deep/.el-textarea__inner{
       
        resize:none
    }
    .el-textarea__inner{
       
        resize:none
    }
    .yueTimePicker{
      .el-picker-panel__footer{
        .el-button--text {
          display: none;
        }
      }
    }
    .el-message-box__message{
      white-space: pre-wrap;
    }
    .guanjiaDialog{
      .el-dialog{
        background: linear-gradient(171deg, #D5F2FF 4.04%, #F8F8FA 61.16%);
        border-radius: 8px;
        .el-dialog__body{
           position: relative;
          .kefuIcon{
            position: absolute;
            top: -2px;
            background: #F52A2A;
            border-radius: 2px;
            width: 56px;
            font-size: 12px;
            color: #fff;
            font-weight: 700;
            line-height: 21px;
            b{
              position: absolute;
              bottom: -5px;
              left: 0;
              width: 0;
              height: 0;
              border: 5px solid #F52A2A;
              border-top-color: rgba(0, 0, 0, 0.00);
              border-bottom-color: rgba(0, 0, 0, 0.00);
              border-right-color: rgba(0, 0, 0, 0.00);
            }
          }
        }
      }
      img{
        width: 200px;
        height: 200px;
        margin-top: 20px;
      }
      .text1{
        font-size: 24px;
        font-weight: 900;
        color: #262F47;
        text-align: left;
      }
      .text2{
        margin-top: 8px;
        font-size: 14px;
        color: #262F47;
        text-align: left;
      }
      .text3{
        color: #BFC1CE;
        font-size: 14px;
        margin-top: 4px;
        text-align: left;
      }
      .imgBox{
        width: 392px;
        height: 264px;
        background: #fff;
        margin-top: 24px;
        margin-bottom: 24px;
        border-radius: 8px;
      }
      .rzTit{
        color: #262F47;
        font-size: 18px;
        font-weight: 800;
        margin-top: 24px;
      }
      .rzDesc{
        color: #51596C;
        font-size: 14px;
        margin-top: 4px;
       
      }
      a{
        display: inline-block;
        width: 100%;
        height: 44px;
        background: #30333D;
        line-height: 44px;
        color: #fff;
        font-weight: 700;
      }
    }
    .cannotXD{
      width: 445px;
      .el-message-box__header{
        padding: 24px;
        padding-bottom: 0;
      }
      .el-message-box__title{
        font-size: 18px;
        font-weight: 800;
        color: #262F47;
      }
      .el-message-box__content{
        padding: 10px 24px;
      }
      .el-message-box__btns{
        padding:24px 24px 14px 24px;
        .el-button{
          width: 190px;
          height: 44px;
        }
      }
      .el-message-box__headerbtn{
        display: none;
      }
    }
  .app-help-btn{
    position: fixed;
    // z-index: 9999;
    bottom: 24px;
    right: 24px;
    width: 88px;
    height: 54px;
    padding: 10px;
    border-radius: 54px;
    background: var(--background-background-white, #FFF);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.09), 1px 1px 2px 0px rgba(0, 0, 0, 0.09), 2px 4px 4px 0px rgba(0, 0, 0, 0.08), 5px 8px 6px 0px rgba(0, 0, 0, 0.04), 9px 15px 7px 0px rgba(0, 0, 0, 0.01), 15px 23px 8px 0px rgba(0, 0, 0, 0.00);
    color: var(--sys-primary, #30333D);
    font-family: Inter;
    font-size: 24px;
    font-weight: 900;
    cursor: pointer;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue